export const digitsOnly = (value: string) => value.replace(/\D/g, '');

export const formatPhoneNumber = (phone?: string | null): string => {
  if (!phone) {
    return '';
  }

  const digits = digitsOnly(phone).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
